import { useTheme as useThemeBase } from 'emotion-theming';

export const useTheme = () => useThemeBase();
